import { Request } from 'api';
import { AxiosResponse } from 'axios';

type ReturnType = Promise<AxiosResponse<{ hidden_organization_uuids: string[] }>>;

const updateHiddenOrganizations = (hiddenOrganizationUuids: string[]): ReturnType => {
    return Request.put('/users/hidden-organizations', {
        hidden_organization_uuids: hiddenOrganizationUuids,
    });
};

export default updateHiddenOrganizations;
